import { api } from '../api/client.js'
import { useAuthStore } from '../store/authStore.js'

/**
 * Full sign-out: revoke the server session, THEN clear local auth state.
 *
 * The server call is what removes the `active-session:*` and `refresh-family:*`
 * Redis keys. Skipping it (as several logout buttons used to) leaves those keys
 * alive for their 7-day TTL, so the user's next login is rejected with
 * `ALREADY_LOGGED_IN` until Redis is flushed or the API restarts.
 *
 * The server call is best-effort: a network failure, an already-expired session
 * (401), or a CSRF rejection must not trap the user in the app. We always fall
 * through to `clearSession()` and let the caller navigate to the login page.
 */
export async function logout(): Promise<void> {
  try {
    await api.post('/auth/logout')
  } catch {
    // best-effort — session may already be gone, or the network is down.
    // Local state is still cleared below so the user is not stuck.
  }
  useAuthStore.getState().clearSession()
}
